import React from 'react'

function ManageGallery() {
  return (
    <div>ManageGallery</div>
  )
}

export default ManageGallery